<template>
  <div>
    <div class="content-block">
      <h1>Blog</h1>
      <p>Filter by tags:</p>
      <div class="tags">
        <span class="tag" :class="[tag === activeTag ? 'tag--active': '']" v-for="tag in tags"
              v-on:click="selectTag(tag)">
          {{tag}}
        </span>
      </div>
    </div>
    <div class="content-block" v-for="post in posts" v-if="!activeTag || post.tags.indexOf(activeTag) >= 0">
      <router-link :to="post.path">
        <h3>{{post.name}}</h3>
        <p>{{post.abstract}}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
  let posts = [
    {
      name: 'Infosophy',
      path: '/blog/infosophy',
      abstract: 'What informatics and philosophy can learn from each other.',
      tags: ['informatics', 'philosophy']
    }
  ];
  let tags = [];
  for (let post of posts) {
    for (let tag of post.tags) {
      if (tags.indexOf(tag) === -1) {
        tags.push(tag);
      }
    }
  }
  export default {
    name: 'blog',
    data () {
      return {
        posts: posts,
        tags: tags,
        activeTag: null,
        selectTag(tag) {
          if (this.activeTag === tag) {
            this.activeTag = null;
          } else {
            this.activeTag = tag;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .tags {
    margin-bottom: 1rem;
  }

  .tag {
    background-color: var(--color-purple);
    color: var(--color-black);
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    margin-right: 2px;
    padding: .25rem;
    transition: background-color .15s ease-out;
    user-select: none;
  }

  .tag:hover,
  .tag--active {
    background-color: var(--color-yellow);
  }
</style>



// WEBPACK FOOTER //
// blog.vue?6976420f